<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <!-- <ion-button @click="cancelFilters()">
          <ion-icon :icon="closeOutline"></ion-icon>
        </ion-button> -->
      </ion-buttons>
      <ion-title :style="{textAlign: 'center'}">
        Filtros
      </ion-title>
      <ion-buttons slot="end">
        <ion-fab-button v-if="!computedAnyOpen" size="small" :strong="true" @click="setAlgoliaFilters">
          <ion-icon :icon="checkmark"></ion-icon>
        </ion-fab-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-content>
    <ion-row>
      <template
          v-for="filter in filters"
          :key="filter.filterKey">
        <ion-col
          v-show="!computedAnyOpen || filter.open"
          :size="'12'">
          <ion-button
            v-if="filter.source === 'select'" 
            expand="full"
            :disabled="filter.loading"
            :fill="!model[filter.value] || model[filter.value].length === 0 ? 'outline' : 'solid'"
            :color="model[filter.value] && model[filter.value].length > 0 ? 'success' : ''"
            @click="showAlert({ filter })">
            <ion-badge color="warning" v-if="filter.multiple && model[filter.value] && model[filter.value].length > 0">
              <!-- {{ filter.multiple ?  : ''  }} -->
              <ion-icon :icon="checkmark"></ion-icon>
            </ion-badge>
            {{ filter.filterLabel || filter.label }}
            <span v-if="!filter.multiple && model[filter.value]">
              : <b>{{ filter.items.find(i => i.value === model[filter.value]).text }}</b> 
            </span>
          </ion-button>
          <template v-else-if="filter.source === 'date-picker'" >
            <ion-button
              expand="full"
              v-show="!filter.open"
              :fill="!model[filter.value] ? 'outline' : 'solid'"
              :color="model[filter.value] ? 'success' : ''"
              @click="($event) => open({$event, filter})">
              {{ filter.label }}
              <span v-show="model[filter.value]">
                : <b>{{ formatDatePickerTextField({filter}) }}</b> 
              </span>
            </ion-button>
            <ion-item v-show="filter.open">
              <ion-label>{{(filter.range) ? 'De:' : filter.label}}</ion-label>
              <ion-datetime-button :datetime="`datetime-${filter.value}${(filter.range) ? '-0' : ''}`"></ion-datetime-button>
            </ion-item>
            <ion-modal :keep-contents-mounted="true" :ref="`filter-datetime-${filter.value}${(filter.range) ? '-0' : ''}`">
              <ion-datetime 
                :id="`datetime-${filter.value}${(filter.range) ? '-0' : ''}`"
                locale="pt-BR"
                v-model="model[`${filter.value}${(filter.range) ? '-0' : ''}`]"
                :value="model[`${filter.value}${(filter.range) ? '-0' : ''}`]"
                displayFormat="DD/MM/YYYY"
                presentation="date"
                max="2099-12-31"
                :style="{textColor: 'white'}"
                clear-text="Limpar"
                @ionChange="modalDismiss(`filter-datetime-${filter.value}${(filter.range) ? '-0' : ''}`);if(!filter.range){changeDateTime(filter, value)}">
              </ion-datetime>
            </ion-modal>
            <ion-item v-show="filter.open && filter.range">
              <ion-label>Até:</ion-label>
              <ion-datetime-button :datetime="`datetime-${filter.value}-1`"></ion-datetime-button>
            </ion-item>
            <ion-modal :keep-contents-mounted="true" :ref="`filter-datetime-${filter.value}-1`">
              <ion-datetime 
                :id="`datetime-${filter.value}-1`"
                locale="pt-BR"
                v-model="model[`${filter.value}-1`]"
                :value="model[`${filter.value}-1`]"
                displayFormat="DD/MM/YYYY"
                presentation="date"
                max="2099-12-31"
                :style="{textColor: 'white'}"
                clear-text="Limpar"
                @ionChange="modalDismiss(`filter-datetime-${filter.value}-1`);changeDateTime(filter, value)">
              </ion-datetime>
            </ion-modal>
            <ion-button
              expand="full"
              v-show="filter.open"
              :fill="'solid'"
              @click="() => filter.open = false">
              <ion-icon :icon="arrowBack"></ion-icon>
              Voltar
            </ion-button>
          </template>
          <template v-else-if="filter.source == 'algolia'">
            <ion-button
              expand="full"
              v-show="!filter.open"
              :fill="!model[filter.algoliaIndex] ? 'outline' : 'solid'"
              :color="model[filter.algoliaIndex] ? 'success' : ''"
              @click="($event) => open({$event, filter})">
              {{ filter.label }}
              <span v-show="model[filter.algoliaIndex]">
                : <b>{{ formatedItemText({filter}) }}</b> 
              </span>
            </ion-button>
            <AutoCompleteAlgolia 
              v-show="filter.open"
              :class="'auto-complete-algolia-filter'"
              v-model="model[filter.algoliaIndex]"
              :modelForm="{...model[filter.algoliaIndex]}" 
              :index="filter.algoliaIndex"
              :filters="filter.facetFilters || []"
              :value="filter.algoliaIndex" 
              :label="filter.label" 
              :options="computedItems[filter.algoliaIndex]" 
              :optionsKey="filter.itemText" 
              :delay="750" 
              :handler="searchFilter" 
              :attributesToHighlight="filter.fieldsToShow" 
              :restrictSearchableAttributes="filter.fieldsToSearch" 
              :autofocus="true"
              @choiced="() => filter.open = false"
              @changed="(value) => changeAutoCompleteAlgolia(filter, value)"> 
            </AutoCompleteAlgolia>
            <ion-button
              expand="full"
              v-show="filter.open"
              :fill="'solid'"
              @click="() => filter.open = false">
              <ion-icon :icon="arrowBack"></ion-icon>
              Voltar
            </ion-button>
          </template>    
          <template v-else-if="filter.source == 'customautocomplete'">
            <ion-button
              expand="full"
              v-show="!filter.open"
              :fill="!model[filter.value] ? 'outline' : 'solid'"
              :color="model[filter.value] ? 'success' : ''"
              @click="($event) => open({$event, filter})">
              {{ filter.filterLabel || filter.label }}
              <span v-show="model[filter.value]">
                : <b>{{ formatedItemText({filter}) }}</b> 
              </span>
            </ion-button>
            <v-custom-autocomplete
              v-show="filter.open"
              v-model="model[filter.value]"
              @click:clear="autocompleteHits[filter.value] = []"
              :index="filter.value"
              :value="filter.value"
              :options="autocompleteHits[filter.value]" 
              :loading="autocompleteLoading[filter.value]"
              :filter="(item, queryText, itemText) => filter.fieldsToShow.some(x => item[x].toLowerCase().includes(queryText.toLowerCase()))"
              :handler="handlerAutocomplete"
              :handlerLoading="handlerAutocompleteLoading"
              :delay="750"
              :asyncSearch="filter.asyncSearch"
              :fieldsToShow="filter.fieldsToShow"
              :fieldsToSearch="filter.fieldsToSearch"
              :item="model"
              :label="filter.label"
              :return-object="filter.returnObject"
              :item-value="filter.itemValue"
              :item-text="filter.itemText"
              :chips="filter.chips"
              :placeholder="filter.placeholder"
              :hint="filter.hint"
              :persistent-hint="filter.persistentHint"
              :small-chips="filter.smallChips"
              :deletableChips="filter.deletableChips"
              :multiple="filter.multiple"
              dense
              clearable
              no-filter
              hide-details
              outlined
              clean
              @change="(value) => changeCustomAutoComplete(filter, value)"> 
            >
            </v-custom-autocomplete>
            <ion-button
              expand="full"
              v-show="filter.open"
              :fill="'solid'"
              @click="() => filter.open = false">
              <ion-icon :icon="arrowBack"></ion-icon>
              Voltar
            </ion-button>
          </template> 
          <ion-progress-bar class="datatable-filters-loading" v-if="filter.loading" type="indeterminate"></ion-progress-bar>   
        </ion-col>
      </template>
    </ion-row>

    <!-- Limpar Filtros -->
    <ion-row v-if="filters && filters.length > 0 && !computedAnyOpen">
      <ion-col size="12" class="col-filter">
        <ion-button  
          fill="outline"
          color="warning"
          @click="clearFilters" 
          size="small" 
          expand="full">
          <ion-icon :icon="closeOutline"></ion-icon>
          Limpar Todos os Filtros
        </ion-button>
      </ion-col>
    </ion-row>

  </ion-content>
</template>

<script>
  import { createNamespacedHelpers, mapState } from 'vuex'
  import store from "../store";
  import AutoCompleteAlgolia from "./AutoCompleteAlgolia.vue"
  import VCustomAutocomplete from "./VCustomAutocomplete.vue";
  const { mapActions: registersActions } = createNamespacedHelpers('registers')
  const { mapState: authState } = createNamespacedHelpers("auth")
  import { 
    arrowBack,
    closeOutline,
    calendarOutline,
    checkmark,
    checkmarkCircle } from "ionicons/icons";
  import {
    alertController,
    IonDatetime,
    IonDatetimeButton,
    IonModal,
    IonItem,
    IonHeader,
    IonToolbar,
    IonLabel,
    isPlatform,
    IonRow,
    // IonModal,
    // IonText,
    IonTitle,
    IonBadge,
    IonContent,
    IonButton,
    IonButtons,
    IonProgressBar,
    IonFabButton,
    IonCol,
    IonSearchbar,
    IonIcon
  } from '@ionic/vue'
  export default {
    name: 'DataTableFilters',
    props: ['filtersProps', 'filtersMounted'],
    components: {
      AutoCompleteAlgolia,
      VCustomAutocomplete,
      IonButton,
      IonContent,
      IonToolbar,
      IonHeader,
      IonItem,
      IonTitle,
      IonLabel,
      IonButtons,
      IonFabButton,
      IonBadge,
      // IonText,
      IonDatetime,
      IonDatetimeButton,
      IonModal,
      IonProgressBar,
      IonRow,
      // IonModal,
      IonCol,
      IonIcon
    },
    emits: ['cancelFilters', 'change'],
    data() {
      return {
        items: [],
        model: {},
        modelFormated: {},
        filters: [],
        algoliaFilters: [],
        chips: null,
        auxData: {},
        autocompleteHits: {},
        autocompleteLoading: {},
      }
    },
    computed: {
      ...mapState(['companySelected']),
      ...authState(["user"]),
      computedItems() {
        return this.items;
      },
      isFiltered() {
        return this.filters.some(filter => {
          if (filter.multiple) {
            return this.model[filter.algoliaIndex].length > 0
          } else {
            return !!this.model[filter.algoliaIndex]
          }
        })
      },
      computedAnyOpen() {
        return this.filters.some(f => f.open)
      }
    },
    methods: {
      ...registersActions(['getOnMongo']),
      modalDismiss(ref) {
        const modal = this.$refs[ref][0].$el
        modal.dismiss();
      },
      formatedItemText({filter}) {
        if (!this.model[filter.algoliaIndex || filter.value]) return ''
        let text = this.model[filter.algoliaIndex || filter.value]
        if (filter.itemText && typeof filter.itemText == 'function') { text = filter.itemText({element: text}) }
        return text.substr(0,20)
      },
      formatDatePickerTextField({filter}) {
        let value = this.model[filter.algoliaIndex || filter.value]
        if (!value) return
        if (filter.range) {
          value = value.map(x => store.$moment(x).format("DD/MM/YYYY")).join(' ~ ')
        } else {
          value = new Date(value+" 00:00")
          if (filter.dateYear && (value instanceof Date)) {
            value = store.$moment(value).format("YYYY");
          }
          else if (filter.datePlusWeek && (value instanceof Date)) {
            value = store.$moment(value).format("DD/MM/YYYY, dddd");
          } else {
            value = store.$moment(value).format("DD/MM/YYYY");
          }
        }
        return value
      },
      open({$event, filter}) {
        this.filters.forEach(f => f.open = false)
        filter.open = !filter.open
      },
      changeAutoCompleteAlgolia(filter, value) {
        // this.items[filter.algoliaIndex] = []
        this.model[filter.algoliaIndex] = value
        this.model = {...this.model}
      },
      changeCustomAutoComplete(filter, value) {
        this.model[filter.value] = value
        this.model = {...this.model}
        filter.open = false
      },
      changeDateTime(filter, value) {
        if (filter.range) {
          this.model[filter.value] = [this.model[`${filter.value}-0`].substr(0,10), this.model[`${filter.value}-1`].substr(0,10)]
        } else {
          this.model[filter.value] = this.model[filter.value].substr(0,10)
        }
        this.model = {...this.model}
        filter.open = false
      },
      async showAlert({filter}) {
        let buttons = []
        
        if (filter.multiple) {
          buttons = [
            ...buttons,
            {
              text: 'Todos',
              icon: 'checkbox-outline',
              cssClass: 'all-none-button',
              handler: () => {

                // check all checkboxes
                alert.inputs = alert.inputs.map((checkbox) => {
                  checkbox.checked = true;
                  return checkbox;
                });

                return false;
              }
            }, 
            {
              text: 'Nenhum',
              cssClass: 'all-none-button',
              handler: () => {
                // uncheck all checkboxes
                alert.inputs = alert.inputs.map((checkbox) => {
                  checkbox.checked = false;
                  return checkbox;
                });

                return false;
              }
            }, 
          ]
        } else {
          buttons = [
            ...buttons,
            {
              text: "Limpar",
              cssClass: 'all-none-button',
              handler: () => {
                alert.inputs = alert.inputs.map((radio) => {
                  radio.checked = false;
                  return radio;
                });
                return false;
              }
            }
          ]
        }

        buttons = [
          ...buttons, 
          {
            text: 'Cancelar',
            role: 'cancel',
            cssClass: 'all-none-button'
          },
          {
            text: 'OK',
            handler: (data) => {
              if (filter.multiple && !data.length) {
                delete this.model[filter.value] 
              } else {
                this.model[filter.value] = data
              }
            }
          }
        ];

        // adjust button order in four button layout for ios
        if (isPlatform('ios')) {
          const okButton = { ...buttons[2] };
          const cancelButton = { ...buttons[3] };
          buttons = [buttons[0], buttons[1], cancelButton, okButton];
        }

        const itemsFilter = filter.items && Array.isArray(filter.items) ? 
          filter.items.map(item => 
          ({
              label: item.text, 
              value: item.value , 
              type: filter.multiple ? 'checkbox': 'radio', 
              checked: filter.multiple ? this.model[filter.value] && this.model[filter.value].some(f => f === item.value) : this.model[filter.value] === item.value
          })) : []

        const alert = await alertController.create({
          header: filter.filterLabel || filter.text,
          inputs: itemsFilter,
          cssClass: 'four-button-alert',
          buttons: [...buttons]
        });

        await alert.present();
      },
      clearFilters() {
        this.model = {}
        // this.resetAuxData()
      },
      async searchFilter(req) {
        // filter.loading = true
        let items = this.items
        // this.items = null
        try {
          const { hits, index } = await req
          items[index].splice(0)
          if (hits) {
            items = {...items, [index]: hits}
          }
        } catch (err) {
          console.error(err)
          items[index].splice(0)
        }
        this.items = items
      },
      setAlgoliaFilters() {
        const algoliaFilters = []
        const filtersMounted = this.model
        this.filters.forEach(filter => {  
          const prop = filter.filterValue
       
          if (!this.model[prop])
            return
          
          if (filter.source === 'select' && filter.multiple) {
            if (this.model[prop].length == 0) {
              return
            }
            const arr = this.model[prop].map(item => `'${item}'`)
            // filtersMounted.push({[filter.filterKey || filter.value]: this.model[prop].map(item => filter.source == 'input' || filter.type == 'select' ? item : item[filter.itemKey || filter.filterItemKey])})
            algoliaFilters.push([`${filter.filterKey || filter.value} IN (${arr})`]);
          } else if (filter.multiple) {
            if (this.model[prop].length == 0) {
              return
            } else {
              const arr = this.model[prop].map(item => `${filter.filterKey || filter.value}:${(filter.source == 'input' || filter.type == 'select') ? item : item[filter.itemKey || filter.filterItemKey] }`)
              // filtersMounted.push({[filter.filterKey || filter.value]: this.model[prop].map(item => filter.source == 'input' || filter.type == 'select' ? item : item[filter.itemKey || filter.filterItemKey])})
              algoliaFilters.push(arr)
            }
          } else if (filter.range){
            let value = this.model[prop]
            if (filter.source == 'date-picker' && (this.companySelected?.groupCompany == 'ore' || filter.removeUnderscore)) value = value.map(x => x.replaceAll('-', ''))
            algoliaFilters.push([`${filter.filterKey || filter.value}~~${value}`])
          } else {
            let value = (typeof this.model[prop] == 'object') ? this.model[prop][filter.itemKey || filter.filterItemKey] : this.model[prop]
            if (filter.source == 'date-picker' && (this.companySelected?.groupCompany == 'ore' || filter.removeUnderscore)) value = value.replaceAll('-', '')
            // filtersMounted.push({[filter.filterKey || filter.value]: value})
            if (filter.markers) {
              algoliaFilters.push([`${filter.filterKey || filter.value}like${value}`])
            } else {
              algoliaFilters.push([`${filter.filterKey || filter.value}:${value}`])
            }
          }
        })
        
        this.algoliaFilters = algoliaFilters
        this.$emit('change', {filters: algoliaFilters, filtersMounted})
      },
      removeFilterItem(filter, item) {
        if (filter.multiple) {
          const idx = this.model[filter.filterValue].indexOf(item)
          this.model[filter.filterValue].splice(idx, 1)
        } else {
          this.model[filter.filterValue] = null
        }
      },
      resetAuxData() {
      },
      cancelFilters () {
        this.$emit('cancelFilters')
      },
      async handlerAutocomplete(req) {
        try {
          const {index, hits, query} = await req;
          this.autocompleteHits[index] = hits 
        } catch (err) {
          this.autocompleteHits[index] = [] 
          console.error(err);
        }
      },
      async handlerAutocompleteLoading(index, bool) {
        try {
          this.autocompleteLoading[index] = bool;
        } catch (err) {
          console.error(err);
        }
      },
      async getData({filter, query}) {
        // this.handlerLoading(this.index, true)
        // this.disabledLoadMore = false
        // const _asyncSearch = store.$_.cloneDeep(this.asyncSearch)
        // if (!this.asyncSearch) return this.handlerLoading(this.index, false)

        let {collection, register = collection, orderBy = [], filters, limit = 999999, orFilters: orFiltersAsync} = filter

        if (!collection || !register || !orderBy) return []
        
        const {user, item} = this

        let orFilters = []
        // if (query && query.trim()) {
        //   for (const field of this.fieldsToSearch) {
        //     orFilters.push({key: field, operator: 'like', value: query})
        //   }
        // }
        if (typeof filters == 'string') { 
          filters = eval(filters) 
        }
        
        if (filters && filters.length > 0) {
          // const item = this.item // Disponivel para Filtro
          filters = filters.map(filter => {
            let { key, operator, value } = filter
            if (typeof value == 'string' && value.includes('${') && value.includes('item.')) {
            // if (typeof value == 'string' && value.includes('${')) {
              filter.value = eval(value)
            } 
            return filter 
          });
        }

        if (typeof orFiltersAsync == 'string') { 
          orFiltersAsync = eval(orFiltersAsync) 
        }

        if (orFiltersAsync && orFiltersAsync.length > 0) {
          // const item = this.item // Disponivel para Filtro
          orFiltersAsync = orFiltersAsync
          .filter(filter => {
            let { when } = filter
            if (typeof when === 'undefined' || when === null) {
              return true
            }

            if (typeof when === 'string' && (when.includes('${') || when.includes('=>'))) {
              when = eval(when)
            }

            if (typeof when === 'function') {
              when = when({item, user})
            }

            if (typeof when === 'string') {
              when = eval(when)
            }
            
            return when
          })

          orFiltersAsync
          .map(filter => {
            let { key, operator, value, when } = filter
            // if (typeof value == 'string' && value.includes('${') && value.includes('item.')) {

            if (typeof value == 'string' && value.includes('${')) {
              filter.value = eval(value)
            } 
            return filter 
          });
          orFilters = [...orFilters, ...orFiltersAsync]

          // if (!orFilters.length) orFilters = null
        }
        
        filter.loading = true
        const results = await this.getOnMongo({
          register, 
          collection, 
          filters: (typeof filters == 'string') ? eval(filters) : filters,
          orFilters, 
          orderBy, 
          limit, 
          getFirestore: true 
        })
        const result = results && results.data ? results && results.data : []
        filter.loading = false
        // this.handlerLoading(this.index, false)
        // return {index: this.index, hits: result, query}
        return result
      },
    },
    created() {
      this.filters = this.filtersProps.map(x => {
        if(['lifeControl.createdAt'].includes(x.value)) {
          x.source = 'date-picker'
          x.range = true
        }
        x.open = false
        if(!x.source) x.source = x.type
        if(!x.filterValue) x.filterValue = x.algoliaIndex || x.filterKey || x.value
        if (x.fieldsToShow) {
          x.itemText = ({element}) => {
            let str = element[x.fieldsToShow[0]]?.trim();
            x.fieldsToShow.slice(1).forEach((field) => {
              str = str + " - " + element[field]?.trim();
            });

            return str;
          };
        }
        return x
      })
      
      this.filters.forEach(async filter => {
        if (filter.source == 'collection') {
          /** @TODO */
          // const algoliaClient = algoliasearch(this.algolia?.appId, this.algolia?.searchApiKey)
          // const algoliaIndex = algoliaClient.initIndex(filter.collectionName)
          // try {
          //   filter.loading = true
          //   const response = await algoliaIndex.search()
            
          //   if (response?.hits) {
          //     filter.values = response.hits.map(hit => hit[filter.collectionField])
          //   } else {
          //     console.warn('Error in algolia search on filter ' + filter.name)
          //     filter.values = []
          //   }
          // } catch (err) {
          //   console.error(err)
          // } finally {
          //   filter.loading = false
          // }
        }  else if (filter.source == 'algolia') {
          // v-model
          if (this.filtersMounted[filter.algoliaIndex]) {
            this.model[filter.algoliaIndex] = this.filtersMounted[filter.algoliaIndex]
          } else if (filter.multiple) {
            this.model[filter.algoliaIndex] = []
          } else {
            this.model[filter.algoliaIndex] = null
          }

          // prop items 
          this.items[filter.algoliaIndex] = []

          // prop item-text
          filter.itemText = ({element}) => {
            if (!filter.fieldsToShow)
              return 'id'
            
            let str = element[filter.fieldsToShow[0]]
            filter.fieldsToShow.slice(1).forEach(field => {
              str = str + ' - ' + element[field]
            })

            return str
          }
          
          // prop no-data-text
          filter.noDataTextDefault = 'Digite algo para pesquisar'
          filter.noDataText = filter.noDataTextDefault

          // prop loading
          filter.loading = false
          
          if (filter.multiple) {
            filter.chips = true
            filter.deletableChips = true
            filter.smallChips = true
            filter.formChips = 1
          }
        } 
        else if (filter.source === 'select') {
          if (filter.collection) {
            this.getData({filter})
            .then(result => 
              filter.items = result.map(r => 
                ({value: r[filter.filterKey], text: filter.fieldsToShow.map(fs => r[fs]).join(' - ')})
              )
            )
          } else if(filter.items && Array.isArray(filter.items)) {
            // filter.items
          } else if (typeof filter.items === 'string') {
            filter.items = eval(filter.items)          
          } else {
          }

          if (this.filtersMounted[filter.value]) {
            this.model[filter.value] = this.filtersMounted[filter.value]
          }
        } 
        else if (filter.markers) {
          const { markers } =filter
          let markersObj = Object.keys(markers)
          .filter(m => m.trim() !== 'mobile')
          .map(m => m.toUpperCase())

          markersObj = [...new Set(markersObj)]
          
          filter.items = markersObj.map(m => ({ value: m, text: m}))
          .sort((m1, m2) => m1.value < m2.value ? 1 : m2.value < m1.value ? -1 : 0)

          // filter.values = filter.markers
          filter.source = 'select'

          if (this.filtersMounted[filter.value]) {
            this.model[filter.value] = this.filtersMounted[filter.value]
          }
        }
        else if (this.filtersMounted[filter.value]) {
          this.model[filter.value] = filter.date ? this.filtersMounted[filter.value].substr(0,10) : this.filtersMounted[filter.value]
        }
      })
    },
    setup() {
      return {
        arrowBack,
        closeOutline,
        calendarOutline,
        checkmark,
        checkmarkCircle
      };
    }
  }
</script>

<style>
  .four-button-alert.md .alert-button-group-vertical {
    display: block;
  }
  .four-button-alert.md .alert-button-group-vertical * {
    margin: 0;
    font-size: .9em;
  }
  .four-button-alert.md .alert-button-group-vertical button:nth-of-type(1), 
  .four-button-alert.md .alert-button-group-vertical button:nth-of-type(2) {
    float: left;
    color: var(--ion-color-medium);
  }

  .four-button-alert.md .alert-button-group-vertical button:nth-of-type(3), 
  .four-button-alert.md .alert-button-group-vertical button:nth-of-type(4) {
    float: right;
  }

  .four-button-alert.ios .alert-button-group-vertical {
    flex-direction: row !important;
  }
  .four-button-alert.ios .alert-button-group-vertical button:nth-of-type(1) {
    color: var(--ion-color-medium);
  }
  .four-button-alert.ios .alert-button-group-vertical button:nth-of-type(2) {
    color: var(--ion-color-medium);
    border-right: none;
  }
  .col-filter *:not(ion-icon,ion-badge) {
    padding: 0;
    font-size: .6em;
  }
  .searchbar-datatable div {
    padding: 0;
    font-size: .6em;
  }
  ion-searchbar .searchbar-input-container .searchbar-input{
    border-radius: 25px !important;
  }
  .ion-item-date-picker-filter {
    color: var(--ion-color-primary)!important;
    height: 2.5em;
  }
  .ion-item-date-picker-filter.item-has-value {
    color: white!important;
    background: var(--ion-color-success)!important;
    height: 2.5em;
  }
  .ion-item-date-picker-filter {
    padding: 0;
    margin: 0;
    font-size: .9em;
    text-align: center;
    --border-style: unset;
    border-top: .15em solid var(--ion-color-primary);
    border-bottom: .15em solid var(--ion-color-primary);
  }
  .ion-item-date-picker-filter.item-has-value {
    border-top: unset;
    border-bottom: unset;
  }
  .auto-complete-algolia-filter ion-label, .auto-complete-algolia-filter * {
    color: var(--ion-color-primary)!important;
  }
  .auto-complete-algolia-filter input {
    font-size: .6em;
  }
  .auto-complete-algolia-filter {
    border-top: .15em solid var(--ion-color-primary);
    border-bottom: .15em solid var(--ion-color-primary);
  }
  .ion-item-date-picker-filter ion-label {
    padding: 0;
    margin: 0;
    color: var(--ion-color-primary)!important;
    min-height: 36px!important;
    min-width: .5em!important;
  }
  .ion-item-date-picker-filter.item-has-value ion-label {
    color: white!important;
  }
  .ion-item-date-picker-filter ion-datetime { 
    padding: 0;
    margin: 0;
    min-height: 36px!important;
    font-weight: bold;
  }
  .ion-item-date-picker-filter ion-datetime button { 
    padding: 0;
    height: .9em;
  }
  .clear-datetime {
    position: absolute;
    top: .1em;
    right: 1em;
    cursor: pointer;
  }
  .box {
    border-color: rgba(0, 0, 0, 0.2);
    border-width: thin;
    border-style: solid;
    border-radius: .5em;
    padding: 0;
    margin-bottom: .01em;
    margin-top: .2em;
    box-shadow: .1em .1em .2em .1em rgba(0, 0, 0, 0.2);
    font-family: Open Sans,sans-serif!important;
    color: rgba(0, 0, 0, 0.671);
  }
  
  .datatable-filters-loading {
    top: -.6em;
    height: .25em;
    padding: 0!important;
    margin: 0!important;
  }
</style>